// @flow

import * as React from 'react';
import styled from 'styled-components';

type Props = {
  right?: number,
  left?: number,
  zIndex: number,
  position: 'fixed' | 'absolute',
  children: React.Node,
};

export default function TrayContainer(props: Props) {
  return (
    <Container
      right={props.right}
      left={props.left}
      zIndex={props.zIndex}
      position={props.position}
    >
      {React.Children.map(props.children, (child) => (
        <ChildWrapper>{child}</ChildWrapper>
      ))}
    </Container>
  );
}

TrayContainer.defaultProps = {
  right: 30,
  zIndex: 1,
  position: 'absolute',
};

const Container = styled.div`
  position: ${(props) => props.position};
  bottom: 0;
  ${(props) =>
    props.left ? `left: ${props.left}px;` : `right: ${props.right}px;`}
  display: flex;
  align-items: flex-end;
  z-index: ${(props) => props.zIndex};
`;

const ChildWrapper = styled.div`
  & + & {
    margin-left: 30px;
  }
`;
